<template>
	<slot name="trigger" :open="dropdownOpen" :open-dropdown="openDropdown" :close-dropdown="closeDropdown" :toggle-dropdown="toggleDropdown"></slot>
	<Teleport to="#app">
		<div class="fixed z-20 inset-0" :class="{ 'cursor-close': showCloseCursor }" v-cloak v-if="dropdownOpen" @click="closeDropdown"></div>
		<Transition
			enter-from-class="-translate-y-[calc(100%)]"
			leave-to-class="-translate-y-[calc(100%)]"
			enter-active-class="transition-transform duration-700 ease-out"
			leave-active-class="transition-transform duration-700 ease-in"
		>
			<div class="fixed z-30 inset-x-0 ~top-80/104 bg-black inv-rounded-b" ref="dropdown" v-cloak v-if="dropdownOpen">
				<div class="container px-g1 pb-g1 pt-40">
					<slot name="content"></slot>
				</div>
			</div>
		</Transition>
		<Transition
			enter-from-class="!-top-200"
			leave-to-class="!-top-200"
			enter-active-class="transition-[top] duration-700 ease-out"
			leave-active-class="transition-[top] duration-700 ease-in"
		>
			<div class="fixed z-20 inset-x-0 top-[var(--nav-dropdown-height)] ~mt-80/104 h-200 bg-gradient-to-b from-blue-700/45 to-blue-700/0 mix-blend-difference pointer-events-none" v-cloak v-if="dropdownOpen"></div>
		</Transition>
	</Teleport>
</template>

<script setup>
import { ref, useTemplateRef, watch, nextTick, onUnmounted } from "vue";
import { mutations } from "@js/vue/store.js";
import { generateGridHashMarks, generateGridHashMarkBounds, alignHeightWithGrid } from "@js/grid.js";
import { lock, unlock } from "@js/body-scroll-lock.js";

const dropdownOpen = ref(false);

function openDropdown() {
	dropdownOpen.value = true;
}

function closeDropdown() {
	dropdownOpen.value = false;
}

function toggleDropdown() {
	dropdownOpen.value = !dropdownOpen.value;
}

const dropdown = useTemplateRef('dropdown')

function updateNavDropdownHeight() {
	if (dropdown.value) {
		mutations.changeNavDropdownHeight(dropdown.value.offsetHeight);
	}
}

const showCloseCursor = ref(false);

watch(dropdownOpen, async (newValue) => {
	if (newValue) {
		lock();
		// Wait for next tick to ensure DOM is updated
		await nextTick();
		showCloseCursor.value = true
		generateGridHashMarks();
		alignHeightWithGrid();
		updateNavDropdownHeight();
		setTimeout(() => {
			generateGridHashMarkBounds();
		}, 700)
	} else {
		unlock();
		mutations.changeNavDropdownHeight(0);
		showCloseCursor.value = false
		setTimeout(() => {
			generateGridHashMarkBounds();
		}, 800)
	}
}, { immediate: true });

function handleKeydown(e) {
	if (e.key === 'Escape' && dropdownOpen.value) {
		closeDropdown();
	}
}

window.addEventListener('resize', updateNavDropdownHeight);
window.addEventListener('keydown', handleKeydown);

onUnmounted(() => {
	window.removeEventListener('resize', updateNavDropdownHeight);
	window.removeEventListener('keydown', handleKeydown);
});

</script>
